
export function init() {
    const DOM = {
        pageTabContent: ".internal-tabs__content",
        pageTabSelector: ".internal-tabs__tab",
    }

    let pageTabSelectorEl = document.querySelectorAll(DOM.pageTabSelector);
    let pageTabContentEl = document.querySelectorAll(DOM.pageTabContent);

    pageTabContentEl.forEach((element, index) => {
        element.style.display = "none";

        if ( index == 0 ) {
            element.style.display = "block";
        }
    })

    pageTabSelectorEl.forEach(element => {
        element.addEventListener("click", function() {
            pageTabContentEl.forEach(element => element.style.display = 'none');
            pageTabSelectorEl.forEach(element => element.classList.remove('active'));
            this.classList.add('active');
            let activeContent = document.querySelector(`${DOM.pageTabContent}[data-content="${this.dataset.content}"]`)
            activeContent.style.display = "block"
            
            if (activeContent === null){
                return;
            }
        })
    })
}
